export const SCORE_TEXT_TOKEN = "{{puntos}}";
export const SCORE_TEXT_ROLE = "score";

export function isScoreTextElement(content) {
	return content?.textRole === SCORE_TEXT_ROLE;
}

export function defaultScoreTextHtml() {
	return `<p>${SCORE_TEXT_TOKEN}</p>`;
}

export function renderScoreTextHtml(html, score) {
	const template = html || defaultScoreTextHtml();
	const n = Number(score);
	const val = Number.isFinite(n) ? String(Math.trunc(n)) : "0";
	return String(template).split(SCORE_TEXT_TOKEN).join(val);
}

export function resolveScoreTextDisplayHtml(content, score) {
	return renderScoreTextHtml(content?.html, score);
}
